import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FOUNDER } from "@/lib/data";
import { HOME_SECTIONS } from "@/constants/testIds";
import SectionLabel from "../site/SectionLabel";
import GoldButton from "../site/GoldButton";

export default function Founder() {
  return (
    <section
      data-testid={HOME_SECTIONS.founder}
      className="relative overflow-hidden bg-ink-950 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Portrait */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-ivory/[0.06] bg-ink-800">
              <img
                src={FOUNDER.portrait}
                alt={FOUNDER.name}
                loading="lazy"
                className="h-full w-full object-cover object-[center_35%] grayscale contrast-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-950/50 via-transparent to-transparent" />
              <div className="absolute left-4 top-4 flex items-center gap-3 font-sans text-[10px] uppercase tracking-widest text-gold">
                <span className="h-px w-6 bg-gold" />
                Founder Portrait
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-display text-3xl leading-tight tracking-tight text-ivory">
                  {FOUNDER.name}
                </div>
                <div className="mt-2 font-sans text-xs uppercase tracking-widest text-ivory-muted">
                  {FOUNDER.role}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content */}
          <div className="lg:col-span-7">
            <SectionLabel number="06">Founder</SectionLabel>
            <h2 className="mt-6 font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
              {FOUNDER.headline.split(" ").slice(0, -3).join(" ")}{" "}
              <span className="italic text-gold">
                {FOUNDER.headline.split(" ").slice(-3).join(" ")}
              </span>
            </h2>
            <p className="mt-8 max-w-xl font-sans text-base leading-relaxed text-ivory-soft lg:text-lg">
              {FOUNDER.intro}
            </p>

            <div className="mt-12 border-t border-ivory/[0.06]">
              {FOUNDER.timeline.map((t, i) => (
                <motion.div
                  key={t.year}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.04 }}
                  className="grid grid-cols-[100px_1fr] gap-6 border-b border-ivory/[0.06] py-4 lg:grid-cols-[140px_1fr]"
                >
                  <div className="font-display text-2xl italic text-gold">{t.year}</div>
                  <div className="font-sans text-sm text-ivory lg:text-base">{t.label}</div>
                </motion.div>
              ))}
            </div>

            <div className="mt-10">
              <GoldButton to="/founder" variant="line">
                Read the full founder profile
              </GoldButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
